import {Switch} from "@headlessui/react";
import {ReactElement} from "react";
import {ReactComponent as CheckMarkIcon} from "components/Icons/checkmark.svg";

export interface CheckboxProps {
    checked: boolean
    setChecked?: (checked: boolean) => void
}

export function Checkbox(props: CheckboxProps): ReactElement {
    const setChecked = props.setChecked ?? (() => {});
    return (
        <Switch
            checked={props.checked}
            onChange={setChecked}
            as="div"
            className={`h-full aspect-square rounded-full overflow-hidden flex justify-center items-center
                        ${props.checked ?
                            'border-none bg-primary' :
                            'border border-gray-1 bg-white'}`}
        >
            {props.checked && <CheckMarkIcon className="h-1/2 text-white pt-px"/>}
        </Switch>
    );
}